export default "__VITE_ASSET__3e3f6255__"